<!-- eslint-disable max-len -->
<template>
  <div>
    <h4>BEASISWA</h4>

    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="openEditModal">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            v-if="!readOnly"
            class="btn grey btn-import-form m__r--5"
            @click="$refs.modalCreate.show()">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
        </b-form>
      </div>

      <div
        slot="masih_menerima"
        slot-scope="props"
        @click="clickDetail(props.row)">
        {{ props.row.masih_menerima ? 'Ya' : 'Tidak' }}
      </div>
    </v-server-table>
    <jLoadingTable v-if="!load_first"/>

    <b-modal
      ref="modalCreate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Create Data Beasiswa</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.jenis.$error}">
            <label> Jenis Beasiswa </label>
            <j-input
              v-model="$v.data_master.jenis.$model"
              placeholder="Jenis Beasiswa"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.keterangan.$error}">
            <label> Keterangan </label>
            <j-input
              v-model="$v.data_master.keterangan.$model"
              placeholder="Keterangan"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.dari_tahun.$error}">
            <label> Tahun Mulai </label>
            <j-input
              v-model="$v.data_master.dari_tahun.$model"
              type="number"
              placeholder="Tahun Mulai"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.sampai_tahun.$error}">
            <label> Tahun Akhir </label>
            <j-input
              v-model="$v.data_master.sampai_tahun.$model"
              type="number"
              placeholder="Tahun Akhir"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.masih_menerima.$error}">
            <label> Masih Menerima </label>
            <b-form-radio-group
              v-model="$v.data_master.masih_menerima.$model"
              :options="list_yes_no"
              :stacked="true"
              :disabled="false"
              class="jFormGroup"/>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn blue m__r--5"
          @click="saveData">
          Save
        </b-button>
        <b-button
          class="btn gray"
          @click="closeModalCreate">
          Cancel
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="modalUpdate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Update Data Beasiswa</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.jenis.$error}">
            <label> Jenis Beasiswa </label>
            <j-input
              v-model="$v.data_master.jenis.$model"
              :disabled="readOnly"
              placeholder="Jenis Beasiswa"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.keterangan.$error}">
            <label> Keterangan </label>
            <j-input
              v-model="$v.data_master.keterangan.$model"
              :disabled="readOnly"
              placeholder="Keterangan"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.dari_tahun.$error}">
            <label> Tahun Mulai </label>
            <j-input
              v-model="$v.data_master.dari_tahun.$model"
              :disabled="readOnly"
              type="number"
              placeholder="Tahun Mulai"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.sampai_tahun.$error}">
            <label> Tahun Akhir </label>
            <j-input
              v-model="$v.data_master.sampai_tahun.$model"
              :disabled="readOnly"
              type="number"
              placeholder="Tahun Akhir"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.masih_menerima.$error}">
            <label> Masih Menerima </label>
            <b-form-radio-group
              v-model="$v.data_master.masih_menerima.$model"
              :options="list_yes_no"
              :stacked="true"
              :disabled="readOnly"
              class="jFormGroup"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-button
            v-if="!readOnly"
            class="btn red m__t--20"
            @click="deleteData">
            Delete
          </b-button>
        </b-col>
        <b-col md="6">
          <div class="float-to-right m__t--20">
            <b-button
              v-if="!readOnly"
              class="btn blue m__r--5"
              @click="updateData">
              Update
            </b-button>
            <b-button
              class="btn gray"
              @click="closeModalUpdate">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiKurikulum from '@/services/jApiKurikulum';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  // eslint-disable-next-line
  name: 'jBeasiswa',
  components: {
    jLoadingTable,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      load_first: false,
      data_table: [],
      selected_rows: [],
      columns: ['jenis', 'keterangan', 'dari_tahun', 'sampai_tahun', 'masih_menerima'],
      options: {
        headings: {
          jenis: 'JENIS BEASISWA',
          keterangan: 'KETERANGAN',
          dari_tahun: 'TAHUN MULAI',
          sampai_tahun: 'TAHUN AKHIR',
          masih_menerima: 'MASIH MENERIMA',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: ['jenis', 'keterangan', 'dari_tahun', 'sampai_tahun', 'masih_menerima'],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            id_pegawai: data.id_pegawai,
          };
        },
        requestFunction(data) {
          const getList = jApiKurikulum.getListBeasiswa(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },

      data_master: {
        id_pegawai: this.$route.params.id,
        jenis: '',
        keterangan: '',
        dari_tahun: null,
        sampai_tahun: null,
        masih_menerima: false,
      },
      list_yes_no: [
        {
          value: true,
          text: 'Ya',
        },
        {
          value: false,
          text: 'Tidak',
        },
      ],
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKurikulum', ['createBeasiswa', 'updateBeasiswa', 'deleteBeasiswa']),

    loading(val) {
      const a = val;
      a.id_pegawai = this.$route.params.id;

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    closeModalCreate() {
      this.$refs.modalCreate.hide();
      this.data_master = {
        id_pegawai: this.$route.params.id,
        jenis: '',
        keterangan: '',
        dari_tahun: null,
        sampai_tahun: null,
        masih_menerima: false,
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    closeModalUpdate() {
      this.$refs.modalUpdate.hide();
      this.data_master = {
        id_pegawai: this.$route.params.id,
        jenis: '',
        keterangan: '',
        dari_tahun: null,
        sampai_tahun: null,
        masih_menerima: false,
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    openEditModal(param) {
      this.$refs.modalUpdate.show();
      this.data_master = {
        id: param.row.id,
        id_pegawai: param.row.id_pegawai,
        jenis: param.row.jenis,
        keterangan: param.row.keterangan,
        dari_tahun: param.row.dari_tahun,
        sampai_tahun: param.row.sampai_tahun,
        masih_menerima: param.row.masih_menerima,
      };
    },

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        this.createBeasiswa(this.data_master).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalCreate();
            }, 1500);
          }
        });
      }
    },

    updateData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        this.updateBeasiswa(this.data_master).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalUpdate();
            }, 1500);
          }
        });
      }
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_master.id,
          };
          this.deleteBeasiswa(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        }
      });
    },
  },
  validations() {
    return {
      data_master: {
        jenis: { required },
        keterangan: { required },
        dari_tahun: { required },
        sampai_tahun: { required },
        masih_menerima: { required },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/kepegawaian/tab-component/jBeasiswa.vue